import React from 'react';
import { Box, Button, Chip, Typography } from '@mui/material';

export interface PillItem {
  id: string;
  label: string;
}

interface SelectedPillsProps {
  items: PillItem[];
  onRemove: (id: string) => void;
  onClear: () => void;
  /** Pills shown before collapsing the rest into "+N more". */
  maxVisible?: number;
}

const SelectedPills: React.FC<SelectedPillsProps> = ({ items, onRemove, onClear, maxVisible = 8 }) => {
  if (!items.length) return null;
  const visible = items.slice(0, maxVisible);
  const hiddenCount = items.length - visible.length;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1.5, py: 1.25, borderBottom: 1, borderColor: 'divider' }}>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 0.75, flex: 1, minWidth: 0 }}>
        {visible.map((item) => (
          <Chip
            key={item.id}
            size="small"
            label={item.label}
            title={item.label}
            onDelete={() => onRemove(item.id)}
            sx={{
              maxWidth: 260,
              height: 28,
              borderRadius: 3.5,
              fontSize: 12,
              fontWeight: 600,
              color: 'brand.onContainer',
              bgcolor: 'brand.container',
              '& .MuiChip-deleteIcon': { color: 'brand.onContainer', fontSize: 16 },
            }}
          />
        ))}
        {hiddenCount > 0 && (
          <Typography sx={{ fontSize: 12, color: 'text.secondary', px: 0.5 }}>
            +{hiddenCount} more
          </Typography>
        )}
      </Box>
      <Button size="small" onClick={onClear} sx={{ height: 28, px: 1.25, borderRadius: 3.5, fontSize: 12, color: 'primary.dark', fontWeight: 600, flexShrink: 0, '&:hover': { bgcolor: 'brand.container' } }}>
        Clear
      </Button>
    </Box>
  );
};

export default SelectedPills;
